import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  CloudArrowDownIcon,
  InformationCircleIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline"

const StepNavigation = ({
  currentStep,
  onPrevious,
  onNext,
  onImport,
  manifest,
  isLoading,
}) => {
  // Get current step message (error or info)
  const getCurrentStepMessage = () => {
    switch (currentStep) {
      case 1:
        if (!manifest) {
          return {
            type: "info",
            message: "Upload a .7z update package to begin"
          }
        }
        return {
          type: "info",
          message: "Package uploaded successfully"
        }
      case 2:
        return {
          type: "info",
          message: "Review the package contents before importing"
        }
      case 3:
        return {
          type: "info",
          message: "Configure import settings and start the import"
        }
      default:
        return null
    }
  }

  // Check if next button should be disabled
  const isNextDisabled = () => {
    switch (currentStep) {
      case 1:
        return !manifest || isLoading
      case 2:
        return !manifest
      default:
        return !manifest
    }
  }

  const currentMessage = getCurrentStepMessage()

  return (
    <div className="bg-admin_canvas border-b border-admin_bordered">
      <div className="px-20 py-4 flex justify-between items-center">
        {/* Left side - Previous button */}
        <div className="flex-shrink-0">
          {currentStep > 1 ? (
            <Button
              variant="admin_secondary"
              onClick={onPrevious}
              disabled={isLoading}
            >
              <ArrowLeftIcon className="w-5 h-5 mr-2" />
              Previous
            </Button>
          ) : (
            <div className="w-24" />
          )}
        </div>

        {/* Center - Message (error or info) */}
        <div className="flex-1 flex justify-center items-center px-4">
          {currentMessage && (
            <div className={`flex items-center space-x-2 ${
              currentMessage.type === 'error' ? 'text-admin_error' : 'text-admin_text_secondary'
            }`}>
              {currentMessage.type === 'error' ? (
                <ExclamationTriangleIcon className="w-5 h-5 flex-shrink-0" />
              ) : (
                <InformationCircleIcon className="w-5 h-5 flex-shrink-0" />
              )}
              <Typography
                variant="admin_txt1"
                className={`text-center whitespace-nowrap ${
                  currentMessage.type === 'error' ? 'text-admin_error' : 'text-admin_text_secondary'
                }`}
              >
                {currentMessage.message}
              </Typography>
            </div>
          )}
        </div>

        {/* Right side - Next/Import button */}
        <div className="flex-shrink-0">
          {currentStep < 3 && manifest && (
            <Button
              variant="admin_primary"
              onClick={onNext}
              disabled={isNextDisabled()}
            >
              Next
              <ArrowRightIcon className="w-5 h-5 ml-2" />
            </Button>
          )}

          {currentStep < 3 && !manifest && (
            <div className="w-24" />
          )}

          {currentStep === 3 && (
            <Button
              variant="admin_primary"
              onClick={onImport}
              loading={isLoading}
              disabled={isLoading}
            >
              <CloudArrowDownIcon className="w-5 h-5 mr-2" />
              Import Update
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default StepNavigation
